<template>
    <div class="container">

        <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
        <h1 v-if="language.includes('es')">Español Básico</h1>  
        <h1 v-else>Elementary Spanish</h1>

        <div v-if="language.includes('es')" class="texto">
            <p>Esta Aplicación Web es para los que inician el aprendizaje del español como segunda lengua, como lengua materna o como lengua extranjera. Es muy útil en las primeras etapas ya que cuenta con un material interactivo y gráfico que se ajusta a las necesidades de los estudiantes principiantes. Se ha diseñado para trabajar por módulos de aprendizaje.</p>
            <p style="text-align: center;"><strong>La finalidad de esta Aplicación Web es apoyar diferentes campos disciplinares y personas que describe de la siguiente manera:</strong></p>
        </div>

        <div v-else class="texto">
            <p>This web application is for those people who start learning Spanish as a second language, as a second language or as a foreign language. Additionaly, this is is designed for people who want to use the mother tongue correctly in writing, grammar, structure and so. Students will need to work through units.</p>
            <p style="text-align: center;"><strong>The purpose of this web application is to support different disciplinary fields and people that it describes as follows:</strong></p>
        </div>

        <div>
            <button class="option_button" @click="mostrarOpcion(1)" :style="[botonActivo === 1 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton1.png?alt=media&token=18daa9ae-0f00-4548-9ca0-e035c8ca4072');"></button>
            <button class="option_button" @click="mostrarOpcion(2)" :style="[botonActivo === 2 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton2.png?alt=media&token=4dd20b6a-dcf3-4297-8609-c92ba3d60fc6');"></button>
            <button class="option_button" @click="mostrarOpcion(3)" :style="[botonActivo === 3 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton3.png?alt=media&token=46c1ab41-ffe9-4394-b13c-db6f4835f7ad');"></button>
            <button class="option_button" @click="mostrarOpcion(4)" :style="[botonActivo === 4 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton4.png?alt=media&token=9c89255d-5f79-4927-80a7-589ef2068709');"></button>
            <button class="option_button" @click="mostrarOpcion(5)" :style="[botonActivo === 5 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton5.png?alt=media&token=40d2a47c-74e6-4f93-af4b-ad1161e5a954');"></button>
            <button class="option_button" @click="mostrarOpcion(6)" :style="[botonActivo === 6 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton6.png?alt=media&token=8b1142ae-2233-4c1c-8157-5bf890456a31');"></button>
            <button class="option_button" @click="mostrarOpcion(7)" :style="[botonActivo === 7 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton7.png?alt=media&token=9d65e3ad-a4ee-4352-8d24-671e84be92c3');"></button>
        </div>

        <div v-if="language.includes('es')">
            <RouterLink to="/registrarse">
                <button class="link_button">Solicitar Acceso</button>
            </RouterLink>
            <RouterLink to="/ingresar">
                <button class="link_button">Acceder</button>
            </RouterLink>
        </div>
        <div v-else>
            <RouterLink to="/registrarse">
                <button class="link_button">Request Access</button>
            </RouterLink>
            <RouterLink to="/ingresar">
                <button class="link_button">Log In</button>
            </RouterLink>
        </div>

        <Popup v-if="TogglePopup" v-on:metodo="cerrarOpcion" :texto="contenido" />

    </div>
    

</template>

<script>
import Popup from '@/components/Popup.vue'

export default {
    name: 'home',
    components: {
        Popup
    },
    mounted() {
        if (this.language.includes('es')) {
            document.title = 'Español Básico'
        } else {
            document.title = 'Elementary Spanish'
        }
    },
    data () {
        return {
            language: navigator.language,
            TogglePopup: false,
            contenido: '',
            botonActivo: false
        }
    },
    methods: {
        mostrarOpcion(numero) {
            switch (numero) {
                case 1:
                    this.botonActivo = 1
                    if (this.language.includes('es')) {
                        this.contenido = 'Personas que aprenden español como lengua extranjera, segunda lengua o lengua materna.'
                    } else {
                        this.contenido = 'People who learn Spanish as a foreign language, second language or mother tongue.'
                    }
                    break
                case 2:
                    this.botonActivo = 2
                    if (this.language.includes('es')) {
                        this.contenido = 'Investigadores y lingüistas que quieren identificar a nivel morfosintáctico el uso del español.'
                    } else {
                        this.contenido = 'Researchers and linguists who want to identify the use of Spanish at a morphosyntactic level.'
                    }
                    break
                case 3:
                    this.botonActivo = 3
                    if (this.language.includes('es')) {
                        this.contenido = 'Antropólogos e historiadores que necesitan analizar los cambios y las raíces del latín que contiene el español.'
                    } else {
                        this.contenido = 'Anthropologists and historians who need to analyze the changes and roots of Latin that Spanish contains.'
                    }
                    break
                case 4: 
                    this.botonActivo = 4
                    if (this.language.includes('es')) {
                        this.contenido = 'Hablantes de español que están las primeros fonemas, grafemas y aspectos morfológicos del idioma.'
                    } else {
                        this.contenido = 'Spanish speakers who are familiar with the first phonemes, graphemes and morphological aspects of the language.'
                    }
                    break
                case 5:
                    this.botonActivo = 5
                    if (this.language.includes('es')) {
                        this.contenido = 'Administradores pedagógicos y maestros de escuelas, colegios, institutos, universidades que necesitan un material adicional para sus currículos educativos con el fin que sus estudiantes aprendan sobre el español y uso de la lengua.'
                    } else {
                        this.contenido = ' Pedagogical administrators and teachers of schools, colleges, institutes, universities who need additional material for their educational curricula in order for their students to learn about Spanish and the use of the language.'
                    }
                    break
                case 6:
                    this.botonActivo = 6
                    if (this.language.includes('es')) {
                        this.contenido = 'Psicólogos, psicopedagogos y terapistas del lenguaje que estudian sobre los comportamientos del ser humano de acuerdo al uso del idioma y la importancia de la conciencia fonológica.'
                    } else {
                        this.contenido = 'Psychologists, educational psychologists and language therapists who study human behavior according to the use of language and the phonological awareness.'
                    }
                    break
                case 7:
                    this.botonActivo = 7
                    if (this.language.includes('es')) {
                        this.contenido = 'Profesores y/o maestros que desean vincular en sus currículos la importancia que sus estudiantes aprendan español, proyectando a sus estudiantes a comunicarse con hablantes nativos de manera natural y fluida en un futuro cercano.'
                    } else {
                        this.contenido = 'Professors and/or teachers who wish to link in their curricula the importance of their students learning Spanish, projecting their students to communicate with native speakers naturally and fluently in the near future.'
                    }
                    break
                default:
                    this.contenido = ''
                    break
            }
            this.TogglePopup = true
        },
        cerrarOpcion() {
            this.TogglePopup = false
            this.botonActivo = false
        }
    }
}
</script>

<style src="@/assets/css/home.css" scoped></style>
